import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ClipboardModule } from 'ngx-clipboard';
import { ConfirmYourCoverComponent } from './components/confirm-your-cover/confirm-your-cover.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { OnboardingComponent } from './components/onboarding/onboarding.component';
import { ProfileComponent } from './components/profile/profile.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { FaqsComponent } from './components/faqs/faqs.component';
import { ViewFaqComponent } from './components/view-faq/view-faq.component';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { ContactFormComponent } from './components/contact-form/contact-form.component';
import { UpdateComponent } from './components/update/update.component';
import { MarketingPreferencesComponent } from './components/marketing-preferences/marketing-preferences.component';
import { AboutComponent } from './components/about/about.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { AppTermsComponent } from './components/app-terms/app-terms.component';
import { YourInsuranceComponent } from './components/your-insurance/your-insurance.component';
import { UpdateInsuranceComponent } from './components/update-insurance/update-insurance.component';
import { ProtectAndSaveComponent } from './components/protect-and-save/protect-and-save.component';
import { ProtectAndSaveProductComponentComponent } from './components/protect-and-save-product-component/protect-and-save-product-component.component';
import { MyUniComponent } from './components/my-uni/my-uni.component';
import { ReferAFriendComponent } from './components/refer-a-friend/refer-a-friend.component';
import { WellbeingComponent } from './components/wellbeing/wellbeing.component';
import { MyInsuranceSectionComponent } from './components/my-insurance-section/my-insurance-section.component';
import { PartnerBannerComponent } from './components/partner-banner/partner-banner.component';
import { PartnerPageComponent } from './components/partner-page/partner-page.component';
import { StudentLifeComponent } from './components/student-life/student-life.component';
import { TopOffersPageComponent } from './components/top-offers/top-offers.component';
import { StudentLifeArticleComponent } from './components/student-life-article/student-life-article.component';
import { StudentLifeCarouselComponent } from './components/student-life-carousel/student-life-carousel.component';
import { WellbeingHelplineComponent } from './components/wellbeing-helpline/wellbeing-helpline.component';
import { GenericTabsComponent } from './components/generic-tabs/generic-tabs.component';
import { SignpostingCardComponent } from './components/signposting-card/signposting-card.component';
import { WellbeingArticleComponent } from './components/wellbeing-article/wellbeing-article.component';
import { MaintenencePageComponent } from './components/maintenence-page/maintenence-page.component';
import { InternationalStudentPageComponent } from './components/international-students/international-student-page.component';
import { MakeAClaimComponent } from './components/make-a-claim/make-a-claim.component';
import { MakeAClaimCardComponent } from './components/make-a-claim-card/make-a-claim-card.component';
import { MakeAClaimFormComponent } from './components/make-a-claim-form/make-a-claim-form.component';
import { InternationalStudentContactUsComponent } from './components/international-student-contact-us/international-student-contact-us.component';
import { PolicySummaryComponent } from './components/policy-summary/policy-summary.component';
import { JobsAndCareersComponent } from './components/jobs-and-careers/jobs-and-careers.component';
import { JobsAndCareersCardComponent } from './components/jobs-and-careers/jobs-and-careers-card/jobs-and-careers-card.component';
import { StudentGuardBannerComponent } from './components/student-guard-banner/student-guard-banner.component';
import { UpdateUniAccommodationUnihomesComponent } from './components/update-uni-accommodation-unihomes/update-uni-accommodation-unihomes.component';
import { JobsAndCareersCarouselSlideComponent } from './components/jobs-and-careers/jobs-and-careers-carousel-slide/jobs-and-careers-carousel-slide.component';
import { ProtectAndSaveDashboardComponentComponent } from './components/protect-and-save/protect-and-save-dashboard-component/protect-and-save-dashboard-component.component';
import { ProtectAndSaveCarouselSlideComponent } from './components/protect-and-save/protect-and-save-carousel-slide/protect-and-save-carousel-slide.component';
import { IgnoreMaintenancePageComponent } from './components/ignore-maintenance-page/ignore-maintenance-page.component';

@NgModule({
    imports: [
    CommonModule,
    DashboardRoutingModule,
    ReactiveFormsModule,
    ClipboardModule,
    ProfileComponent,
    DashboardComponent,
    ConfirmYourCoverComponent,
    OnboardingComponent,
    TermsAndConditionsComponent,
    FaqsComponent,
    ViewFaqComponent,
    ContactUsComponent,
    ContactFormComponent,
    UpdateComponent,
    MarketingPreferencesComponent,
    AboutComponent,
    PrivacyPolicyComponent,
    AppTermsComponent,
    YourInsuranceComponent,
    UpdateInsuranceComponent,
    ProtectAndSaveComponent,
    ProtectAndSaveProductComponentComponent,
    MyUniComponent,
    ReferAFriendComponent,
    WellbeingComponent,
    MyInsuranceSectionComponent,
    PartnerBannerComponent,
    PartnerPageComponent,
    StudentLifeComponent,
    TopOffersPageComponent,
    StudentLifeArticleComponent,
    StudentLifeCarouselComponent,
    WellbeingHelplineComponent,
    GenericTabsComponent,
    SignpostingCardComponent,
    WellbeingArticleComponent,
    MaintenencePageComponent,
    InternationalStudentPageComponent,
    MakeAClaimComponent,
    MakeAClaimCardComponent,
    MakeAClaimFormComponent,
    InternationalStudentContactUsComponent,
    PolicySummaryComponent,
    JobsAndCareersComponent,
    JobsAndCareersCardComponent,
    StudentGuardBannerComponent,
    UpdateUniAccommodationUnihomesComponent,
    JobsAndCareersCarouselSlideComponent,
    ProtectAndSaveDashboardComponentComponent,
    ProtectAndSaveCarouselSlideComponent,
    IgnoreMaintenancePageComponent,
],
    exports: [
        DashboardComponent,
        TermsAndConditionsComponent,
        FaqsComponent,
        ViewFaqComponent,
        UpdateComponent,
        PrivacyPolicyComponent,
        AppTermsComponent,
        YourInsuranceComponent,
        UpdateInsuranceComponent,
        ProtectAndSaveComponent,
        ProtectAndSaveProductComponentComponent,
        MyUniComponent,
        ReferAFriendComponent,
        WellbeingComponent,
    ],
})
export class DashboardModule {}
